module.exports = __webpack_public_path__ + "static/hero-eac3440f3bd2dbae2662f4304b19f03e.svg";